import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { RootRef } from "@material-ui/core";

export const withDroppable = (
  onDragEnd: (event: any, data: any) => void,
  Component: any
) => (props: any) => {
  const dndCallback = async (event: any) => {
    const { destination, source } = event;
    if (
      !destination ||
      (destination.droppableId === source.droppableId &&
        destination.index === source.index)
    ) {
      return;
    }
    onDragEnd(event, props.data);
  };

  return (
    <DragDropContext onDragEnd={dndCallback}>
      <Droppable droppableId="droppable">
        {provided => (
          <RootRef rootRef={provided.innerRef}>
            <Component
              className={props.classes ? props.classes.body : undefined}
            >
              {props.children}
              {provided.placeholder}
            </Component>
          </RootRef>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export interface DraggableComponent {
  isDragged: boolean;
  draggableProps: any;
  ref: any;
}

export const withDraggable = (Component: DraggableComponent & any) => (
  props: any
) => {
  const { idx } = props;
  return (
    <Draggable key={idx + "_key"} draggableId={idx + "_drag"} index={idx}>
      {(provided, snapshot) => (
        <Component
          key={idx + "_row_key"}
          isDragged={snapshot.isDragging}
          draggableProps={{
            ...provided.draggableProps,
            ...provided.dragHandleProps
          }}
          ref={provided.innerRef}
          {...props}
        />
      )}
    </Draggable>
  );
};
